import window from 'window-or-global';

import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
import { getContentId } from '../utils/commons';
import {
	persistRelativeScrollPosition,
	restoreScrollPositionIfNeeded,
} from '@confluence/persistent-scroll-position';
import { getOverride } from '@confluence/meta';

export const plugin = {
	_saveScrollPosition(ed) {
		if (!ed.getDoc() || !ed.getWin()) {
			return;
		}

		persistRelativeScrollPosition({
			contentId: getContentId(),
			isInViewPage: false,
			docObject: ed.getDoc(),
			winObject: ed.getWin(),
		});
	},

	_restoreScrollPositionIfNeeded(ed) {
		if (!ed.getDoc() || !ed.getWin()) {
			return;
		}

		restoreScrollPositionIfNeeded({
			contentId: getContentId(),
			isInViewPage: false,
			docObject: ed.getDoc(),
			winObject: ed.getWin(),
		});
	},

	init: (ed) => {
		// just for edit page
		const contentType = getOverride('content-type');
		if (contentType !== 'page' && contentType !== 'blogpost') {
			return;
		}

		bind('rte-collab-ready', () => {
			plugin._restoreScrollPositionIfNeeded(ed);
		});

		// before quick edit page, need to save scroll position
		bind('rte-ready', () => {
			window.Confluence.Editor.UI.cancelButton.click(() => plugin._saveScrollPosition(ed));
			window.Confluence.Editor.UI.saveButton.click(() => plugin._saveScrollPosition(ed));
		});
	},

	getInfo: () => {
		return {
			longname: 'Persist scroll position for transition between view page and edit page',
			author: 'Atlassian',
			authorurl: 'http://www.atlassian.com',
			version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
		};
	},
};

export default () => {
	window.tinymce.create('tinymce.plugins.PersistScrollPosition', plugin);
	window.tinymce.PluginManager.add(
		'persit_scroll_position',
		window.tinymce.plugins.PersistScrollPosition,
	);
};
